/** 音频播放中 */
export const AUDIO_PLAYING = 1
/** 音频加载中 */
export const AUDIO_LOADING = 2
/** 音频暂停 */
export const AUDIO_PAUSED = 3